// ======================= Imports =======================
import React from "react";
import { useNavigate } from "react-router-dom";
import "./PaymentFailed.css";

// ======================= Main Component =======================
export default function PaymentFailed({
  setIsBankOfAmericaPrepaidPaymentSuceeded,
  setCheckForBankOfAmericaPayment,
}) {
  // ======================= Router =======================
  let navigate = useNavigate();

  // ======================= Render =======================
  return (
    <div className="main-payment fixed  top-0 left-0">
      <div className="main-container flex flex-wrap flex-row justify-content-center align-items-start w-full">
        {/* ======================= Failed Icon ======================= */}
        <div className="check-time-main">
          <i className="pi pi-times" />
        </div>
        {/* ======================= Failed Message ======================= */}
        <h1>Payment Failed!</h1>
        <p>Your Payment Has Been Declined</p>
        {/* ======================= Redirect Button ======================= */}
        <div className="flex flex-wrap w-full flex-row justify-content-center items-center">
          <button
            onClick={() => {
              setIsBankOfAmericaPrepaidPaymentSuceeded(false);
              navigate("/");
              setCheckForBankOfAmericaPayment((prev) => !prev);
            }}
            className="redirect-button"
            label="Redirect Back"
          >
            Redirect Back
          </button>
        </div>
      </div>
    </div>
  );
}
